<template>
  <div class="absolute top-full left-0">
    {{ old }}
  </div>
</template>

<script>

export default {
  props: {
    value: Object,
    old: Object,
  },
}

</script>
